import { render, staticRenderFns } from "./m-edit-multi-select.vue?vue&type=template&id=880d792c&scoped=true&"
import script from "./m-edit-multi-select.vue?vue&type=script&lang=js&"
export * from "./m-edit-multi-select.vue?vue&type=script&lang=js&"
import style0 from "./m-edit-multi-select.vue?vue&type=style&index=0&id=880d792c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880d792c",
  null
  
)

export default component.exports